import type { HandlerFunction } from "../types";
import { useOrgaStore } from "~/stores/orga";
import { useBillingStore } from "~/stores/billing";
/**
 * Organization message handler
 *
 * Handles organization-level SSE events including:
 * - Alerts
 * - Settings updates
 * - Subscription changes
 * - New members
 * - Store updates
 */
export const handleOrgaMessage: HandlerFunction = (data: {
  type: string;
  refresh?: boolean;
  message?: string;
}) => {
  // console.log("[SSE] [handleOrgaMessage]:", data);
  const toast = useToast();
  const orgaStore = useOrgaStore();
  const billingStore = useBillingStore();

  switch (data.type) {
    case "alert":
      // Show organization alert
      break;

    case "settings_update":
      // Refresh organization settings
      orgaStore.triggerRefresh();
      break;

    case "subscription_update":
      // Refresh subscription data
      orgaStore.triggerRefresh();
      billingStore.needRefresh = true;
      break;

    case "new_member":
      // Update member list
      break;

    case "store":
      if (data.refresh) {
        orgaStore.triggerRefresh();
        billingStore.needRefresh = true;
      }
      if (data.message)
        toast.add({
          title: "Success",
          description: data.message,
          color: "group_indigo",
          duration: 2000,
        });
      break;

    default:
      console.log("Unknown orga message type:", data.type);
  }
};
